// Indicative credit-solution parameters and asset classes.
// These come from the existing daksfirst.com /investments page.
// Marked AMBER pending Sumit's confirmation that they still reflect strategy.

export const parameters = [
  ["Size",       "$5m – $100m"],
  ["Rate",       "Floating + 5% to 15% (in USD)"],
  ["Maturity",   "2 – 7 years"],
  ["Currencies", "GBP, EUR, USD, INR, AED"],
  ["Security",   "1st ranking, mezzanine, preferred equity, recourse and non-recourse"],
  ["Fees",       "Flexible (upfront, exit, participation)"],
  ["Coupon",     "Cash + PIK"]
];

export const assetClasses = [
  "Asset finance",
  "Real estate backed loans",
  "Whole loan purchase",
  "LP secondaries",
  "Contract monetisation",
  "Commercial vehicle financing",
  "Corporate lending",
  "Acquisition loans",
  "Growth capital loans",
  "Pre-IPO loans",
  "Lombard loans",
  "Shareholder buyback",
  "Balance sheet restructuring",
  "Working capital incl. trade finance"
];
